// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Text from "components/typography/Text";
import Link from "components/layout/Link";

// #####################################################

const ConvertLocation = ({ location, url }) => {
	const { city, cityId, region, regionId, country, isCityHasUsers } =
		location || {};
	const { t } = useTranslation(["countries", "regions"]);

	const withoutLink = isCityHasUsers === false;

	let locationArray = [
		{
			type: "city",
			isset: (city && city.length > 0) || cityId,
			name: city,
			value: cityId,
		},
		{
			type: "region",
			isset: (region && region.length > 0) || regionId,
			name: regionId ? t(`regions:region_${regionId}`) : region,
			value: regionId,
		},
		{
			type: "country",
			isset: Boolean(country),
			name: country ? t(`countries:${country}`) : country,
			value: country,
		},
	].filter(({ isset }) => isset);

	const cityLocation = locationArray.find(({ type }) => type === "city");
	const countryLocation = locationArray.find(
		({ type }) => type === "country",
	);

	const to = url ? `/search/${url}` : `/search`;

	// #####################################################

	if (withoutLink) {
		return (
			<Text color="whiteAlways">
				{cityLocation?.name}, {countryLocation?.name}
			</Text>
		);
	}

	return (
		<Text color="whiteAlways">
			<Link noColorVisited underline customColor="whiteAlways" to={to}>
				{cityLocation?.name}
			</Link>
			, {countryLocation?.name}
		</Text>
	);
};

// #####################################################

export default ConvertLocation;

// #####################################################
